

(function(){

'use strict';

    // **********************************
    //  DEBUG PRINTER DIRECTIVE
    // ----------------------------------
    //
    //

function pxPrinterDebugMode(
    $timeout, $filter, toastr, $http, DEBUG_MODE_STATE,
    EventServiceEvents
) {
    return {
    restrict: 'EA',
    scope: {
        context: '=context',
        callback: '&callback'
    },
    templateUrl: 'app/components/printerProperties/printerSettings/printerDebugMode/printerDebugMode.template.html',
    link: function(scope) {
        
        scope.printer = scope.context.printer;
        scope.inDebugMode = false;
        scope.uiReady = false;
        
        scope.debugSession = {
            duration: "PT1H",
        };
        var containerElement = document.getElementById('PRINTER_DEBUG_DIALOG_CONTENT');
        scope.currentDebugSession = {};
        
        scope.search = {string: ''}
        scope.auditEvents = [];
        var auditEventListener;

        function DebugLog (data) {
            this.description = data.englishDescription;
            this.timestamp = data.timestamp;
            this._links = {
                self: data.auditEvent
            }
            this._embedded = {
                affectedResources: []
            }

            this.setAffectedResources = (data) => {
                function PrinterAffected (printerId, printerHref) {
                    this.resourceType = "PRINTER";
                    this.resourceId = printerId;
                    this._links = {
                        'px:printer': {
                            href: printerHref
                        }
                    }
                }

                data.relatedPrinters.forEach(printerRef => {
                    const printerId = printerRef.split('/').pop()
                    const printerHref = printerRef;
                    const printer = new PrinterAffected(printerId, printerHref);
                    this._embedded.affectedResources.push(printer);
                })
            }
            return this
        }


        function setState (state) {
            switch(state) {
                case "PREPARING":
                    scope.debugMode = "PREPARING";
                    prepareUI();
                    break;
                case "READY":
                    scope.debugMode = "READY";
                    break;
                case "ACTIVATING":
                    beginDebugMode();
                    break;
                case "ACTIVE":
                    scope.debugMode = "ACTIVE";
                    auditEventListener = setListener();
                    getAuditEvents();
                    break;
                case "RETRIEVE_PREVIOUS_SESSION":
                    retrievePreviousSessionEvents();
                    break;
                case "ENDING":
                    endDebugMode();
                    deregisterListener();
                    break;
                case "ENDED":
                    scope.debugMode = "ENDED";
                    deregisterListener();
                    break;
                case "ERROR":
                    scope.debugMode = "ERROR";
                    deregisterListener();
                    break;
                default:
                    scope.debugMode = "READY";
            }
        }

        setState('PREPARING');

        scope.changeState = function(state) {
            setState(state);
        }

        function deregisterListener () {
            if (auditEventListener) {
                auditEventListener();
            }
        }

        function prepareUI () {
            if (scope.printer.info._links['px:debugMode']) {
                getDebugMode();
            } else {
                setState('READY');
            }
        }

        function getDebugMode () {
            scope.printer.getDebugMode().then(function(debugData) {
                scope.currentDebugSession = debugData;
                if (scope.currentDebugSession.active) {
                    setState('ACTIVE');
                } else {
                    setState('RETRIEVE_PREVIOUS_SESSION');
                }
            }).catch(function(error) {
                toastr.error('Error');
                scope.debugMode = "ERROR";
            })
        }

        function beginDebugMode() {
            scope.auditEvents = [];
            scope.printer.beginDebugMode(scope.debugSession).then(function(debugData) {
                scope.currentDebugSession = debugData;
                setState('ACTIVE');
            }).catch(function(error) {
                toastr.error('Error');
                setState('ERROR');
            });
        }

        function endDebugMode() {
            scope.printer.endDebugMode(scope.currentDebugSession).then(function(response) {
                scope.currentDebugSession = response.data;
                setState('ENDED');
                if (!scope.auditEvents.length) {
                    setState('READY');
                }
            }).catch(function(error) {
                toastr.error('Error');
                scope.debugMode = "ERROR";
            });
        }
        
        function getAuditEvents() {
            scope.printer.getAuditEvents(scope.currentDebugSession).then(function(auditEvents) {
                if (auditEvents.page.totalElements > 0) {
                    scope.auditEvents = auditEvents._embedded['px:auditEventResources'];
                    scrollEnd();
                    
                }
            }).catch(function(error) {
                toastr.error('Error');
                scope.debugMode = "ERROR";
            });
        }

        function retrievePreviousSessionEvents() {
            scope.printer.getAuditEvents(scope.currentDebugSession).then(function(auditEvents) {
                if (auditEvents.page.totalElements > 0) {
                    scope.auditEvents = auditEvents._embedded['px:auditEventResources'];
                    scrollEnd();
                    setState('ENDED');
                } else {
                    setState('READY');
                }
            }).catch(function(error) {
                toastr.error('Error');
                scope.debugMode = "ERROR";
            });
        }

        function scrollEnd () {
            $timeout(function() {
                var element = document.getElementById('AUDIT_EVENT_LIST');
                containerElement.scrollTop = element.scrollHeight;
            }, 50);
        }

        scope.downloadDebugLogs = function() {
            scope.printer.downloadDebugModeLog(scope.currentDebugSession).then(function(response) {
            }).catch(function(error) {});
        }

        scope.closeDebugDialog = function() {
            scope.callback();
        }

        function setListener () {
            return scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.AUDIT_EVENT_CREATED, function(name, data) {
                var printerId = scope.printer.customProperties.id
                if (name.name === 'audit_event_created' && data.relatedPrinters && data.relatedPrinters.length > 0) {
                    var match = data.relatedPrinters.find(printer => printer.includes(printerId));
                    if (match) {
                        const debugLog = new DebugLog(data);
                        debugLog.setAffectedResources(data);
                        scope.auditEvents.push(debugLog);
                        scrollEnd();
                    }
                }
            });
        }

    }};
}

pxPrinterDebugMode.$inject = [
    '$timeout', '$filter', 'toastr', '$http', 'DEBUG_MODE_STATE',
    'EventServiceEvents'
];

angular
    .module('printix-admin')
    .directive('pxPrinterDebugMode', pxPrinterDebugMode)
    .constant('DEBUG_MODE_STATE', [
        "PREPARING",
        "READY",
        "ACTIVE",
        "ENDING",
        "ENDED",
        "ERROR"
    ]);
    

})();

